import {
  Boolean,
  Date,
  DefaultSearchTerms,
  DisplayOrder,
  Hidden,
  Number,
  Options,
  ReadOnly,
  Required,
  String,
  TableDisplayed,
  TableDisplayedDefault,
  TableIdentifier
} from "projects/nter-ui-kit/src/lib/webkit/components/crud-item/crud-item-decorator";

@DefaultSearchTerms(['active:true'])
export class PlatformModule {
  @Number('ID')
  @ReadOnly
  @DisplayOrder(1)
  @TableIdentifier
  id?: number;

  @String('Code')
  @Required
  @DisplayOrder(3)
  @TableDisplayedDefault
  code?: string;

  @Required
  @String('Display name')
  @DisplayOrder(4)
  @TableDisplayedDefault
  name?: string;

  @Required
  @String('Description')
  @DisplayOrder(5)
  @TableDisplayedDefault
  description?: string;

  @Required
  @String('System Code')
  @DisplayOrder(2)
  @Options([{CONSOLE: 'Landlord portal'}, {PORTAL: 'Tenant portal'}])
  @TableDisplayedDefault
  platformSystemCode?: string;

  @Number('')
  @Hidden
  serialVersionUID?: number;

  @Boolean('Active')
  @DisplayOrder(6)
  @TableDisplayedDefault
  active?: boolean = true;

  @Date('Create Date', 'yyyy-MM-dd')
  @Hidden
  @TableDisplayed
  createDate?: string;

  @Number('Create User')
  @Hidden
  @TableDisplayed
  createUserId?: number;

  @Date('Update Date', 'yyyy-MM-dd')
  @Hidden
  @TableDisplayed
  updateDate?: string;

  @Number('Update User')
  @Hidden
  @TableDisplayed
  updateUserId?: number;

  constructor(obj: any = {}) {
    obj = obj || {};
    this.id = obj.id ? obj.id : null;
    this.code = obj.code ? obj.code : null;
    this.name = obj.name ? obj.name : null;
    this.description = obj.description ? obj.description : null;
    this.platformSystemCode = obj.platformSystemCode ? obj.platformSystemCode : null;
    this.serialVersionUID = obj.serialVersionUID ? obj.serialVersionUID : null;
    this.active = obj.active ? obj.active : null;
    this.createDate = obj.createDate ? obj.createDate : null;
    this.createUserId = obj.createUserId ? obj.createUserId : null;
    this.updateDate = obj.updateDate ? obj.updateDate : null;
    this.updateUserId = obj.updateUserId ? obj.updateUserId : null;
  }
}
